export default (state, param) => {
  state.main_email = param.main_email
  state.cc_email_1 = param.cc_email_1
  state.cc_email_2 = param.cc_email_2
  state.cc_email_3 = param.cc_email_3
  state.cc_email_4 = param.cc_email_4
}



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/mutations/setCcEmail.js